var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n';
if( quote.up_down == 'up') {
__p+='\n<tr>\n	<td class="ct_tpdtopright text-center">'+
((__t=(quote.symbol))==null?'':__t)+
'</td>\n	<td class="ct_tpdtopright text-center ct_p6"><span class="ct_ico13"></span> '+
((__t=(quote.bid))==null?'':__t)+
'</td>\n	<td class="ct_tpdtopright text-center ct_p6"><span class="ct_ico13"></span> '+
((__t=(quote.ask))==null?'':__t)+
'</td>\n	<td class="ct_tbdtop text-center">'+
((__t=(quote.spread))==null?'':__t)+
'</td>\n</tr>\n';
} else{ 
__p+='\n<tr>\n	<td class="ct_tpdtopright text-center">'+
((__t=(quote.symbol))==null?'':__t)+
'</td>\n	<td class="ct_tpdtopright text-center ct_p1"><span class="ct_ico14 ct_p1"></span> '+
((__t=(quote.bid))==null?'':__t)+
'</td>\n	<td class="ct_tpdtopright text-center ct_p1"><span class="ct_ico14 ct_p1"></span> '+
((__t=(quote.ask))==null?'':__t)+
'</td>\n	<td class="ct_tbdtop text-center">'+
((__t=(quote.spread))==null?'':__t)+
'</td>\n</tr>\n';
}
__p+='\n\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/templates/w/trading/forex_quote_list_item.html
// module id = 53
// module chunks = 0